import React from "react";
import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";
import Tooltip from "./Tooltip";
import { useIsMobileWidth } from "@src/utils/mediaQuery";

const TitleWithTooltip = (props) => {
  const {
    tooltipContent = "",
    tooltipRightPosition = 6,
    title = "",
    centered = true,
    bgColor,
    textColor = "neutral",
    underlined,
  } = props;
  const isMobile = useIsMobileWidth();

  return (
    <div
      className={`text-${textColor}-500 text-base font-bold mb-6 relative ${centered ? "text-center" : ""} ${underlined ? "border-b-2" : ""} ${bgColor ? `bg-${bgColor}-200` : ""}`}
    >
      {!!tooltipContent && (
        <Tooltip
          content={[tooltipContent]}
          direction={isMobile ? "down-left" : "down-right"}
          rightPosition={tooltipRightPosition}
        />
      )}
      {title}
    </div>
  );
};

export const titleWithTooltipControls = {
  tooltipContent: {
    propType: PropTypes.string,
    description: "Tooltip content",
    controlType: "string",
  },
  title: {
    propType: PropTypes.string,
    description: "Title content",
    controlType: "string",
  },
  textColor: {
    propType: PropTypes.string,
    description: "The color name for the text",
    controlType: "select",
    options: ["primary", "orange", "pink", "black"],
  },
  bgColor: {
    propType: PropTypes.string,
    description: "The color name for the background",
    controlType: "select",
    options: ["primary", "orange", "pink", "black"],
  },
  centered: {
    propType: PropTypes.bool,
    description: "Whether the title text is centered or not",
    controlType: "boolean",
  },
  underlined: {
    propType: PropTypes.bool,
    description: "Whether the title text has a line underneath",
    controlType: "boolean",
  },
};

TitleWithTooltip.propTypes = AppUtils.getPropTypeFromControls(
  titleWithTooltipControls,
);

export default TitleWithTooltip;
